import React from 'react'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom"
import { BaseStyles, Container } from './styles'
import Home from './pages/Home'
import Store from './pages/Store'
import Help from './pages/Help'
import Purchases from './pages/Purchases'
import Register from './pages/Register'
import NoMatch from './pages/NoMatch'
import PrivateRoute from './routes'
import Gift from './pages/Gift'
import Stars from './pages/Stars'
import Tiers from './pages/Tiers'

export default () => (
  <Router>
    <BaseStyles />
    <Container>
      <Switch>
        <PrivateRoute exact path="/">
          <Home />
        </PrivateRoute>
        <PrivateRoute path="/help">
          <Help />
        </PrivateRoute>
        <PrivateRoute path="/purchases">
          <Purchases />
        </PrivateRoute>
        <PrivateRoute path="/register">
          <Register />
        </PrivateRoute>
        <PrivateRoute path="/stars">
          <Stars />
        </PrivateRoute>
        <PrivateRoute path="/tires">
          <Tiers />
        </PrivateRoute>
        <PrivateRoute path="/store">
          <Store />
        </PrivateRoute>
        <PrivateRoute path="/gift/:paid/:id">
          <Gift />
        </PrivateRoute>
        <Route path="*">
          <NoMatch />
        </Route>
      </Switch>
    </Container>
  </Router>
)